<template>
  <div id="app" v-bind:class="{ home: this.$route.path == '/' }">
    <router-view :key="$route.path"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style src="./styles/global.scss" lang="scss"></style>

<style lang="scss">
@import "/styles/_mixins.scss";
body {
	font-family: $montserrat;
	margin: 0px;
	padding: 0px;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;  
}
</style>



// WEBPACK FOOTER //
// App.vue?66e7eef4